import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50" aria-labelledby="cta-title">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="w-full rounded-3xl overflow-hidden mb-10 md:mb-14">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20of%20glowing%20lime%20green%20neon%20message%20bubbles%20floating%20in%20dark%20space%2C%20modern%20digital%20communication%20aesthetic%2C%20mysterious%20anonymous%20tip%20line%20concept%2C%20cinematic%20atmosphere%20with%20film%20grain%20texture%2C%20warm%20dark%20tones%20with%20bright%20neon%20accents%2C%20editorial%20photography%20style%2C%20secretive%20and%20intriguing%20mood%2C%20no%20text%20or%20faces&width=1400&height=600&seq=cta-submit-tip&orientation=landscape"
            alt="向吃瓜51提交爆料线索"
            title="吃瓜51爆料线索提交 - 吃瓜51网"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        <div className="text-center max-w-2xl mx-auto">
          <p className="font-body text-lg md:text-2xl text-foreground-700 leading-relaxed mb-3">
            你有<span className="italic text-foreground-400 font-light">独家内幕</span>？
          </p>
          <p className="font-heading font-black text-2xl md:text-3xl text-foreground-950 leading-snug mb-2">
            欢迎向吃瓜51提交<strong>爆料线索</strong>
          </p>
          <p className="font-body text-lg md:text-2xl text-foreground-700 leading-relaxed mb-8">
            保护爆料人隐私，<span className="italic text-foreground-400 font-light">严格匿名</span>
          </p>

          <Link
            to="/about#contact"
            className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-label font-bold bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            立即爆料
            <i className="ri-send-plane-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}